import styled from 'styled-components';

const CARRIER_LOGO_SIZE = 40;

export const CarrierLogoImage = styled.img(({ theme }) => ({
  border: `1px solid ${theme.colors.surface05}`,
  objectFit: 'cover',
  objectPosition: 'center',
  borderRadius: 2,
  width: CARRIER_LOGO_SIZE,
  height: CARRIER_LOGO_SIZE,
}));
